module.exports = __webpack_public_path__ + "static/img/3.9931225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hjzz/3.png
// module id = Dr57
// module chunks = 1